<template>
  <ResumeSection v-if="data"
                 :toggle="!isToggleHidden"
                 :isOpen="isOpenOnMobile"
                 :title="$tResumePage('Interaction')"
                 class="resume-page__section">
    <template v-slot:icon>
      <BaseSvg name="ico-push-pull" width="2.6rem" height="3rem"/>
    </template>
    <template v-slot:default>
      <div class="resume-documents">
        <div class="resume-documents__inner">
          <template v-if="dataMain">
            <ResumeDocumentsGroup v-for="(item, index) in dataMain"
                                  :key="index"
                                  :item="item"/>
          </template>

          <div v-if="data.personBodyCharacteristics"
               class="resume-documents__info-list-wrap">
            <div class="resume-documents__info-list">
              <div v-if="data.personBodyCharacteristics.height"
                   class="resume-documents__info-list-item">
                <div class="resume-documents__info-list-title">{{ $tResumePage('Interaction person height') }}</div>
                <div class="resume-documents__info-list-subtitle">{{ data.personBodyCharacteristics.height }}</div>
              </div>
              <div v-if="data.personBodyCharacteristics.weight"
                   class="resume-documents__info-list-item">
                <div class="resume-documents__info-list-title">{{ $tResumePage('Interaction person weight') }}</div>
                <div class="resume-documents__info-list-subtitle">{{ data.personBodyCharacteristics.weight }}</div>
              </div>
              <div v-if="data.personBodyCharacteristics.clothing_size"
                   class="resume-documents__info-list-item">
                <div class="resume-documents__info-list-title">{{ $tResumePage('Interaction person clothing_size') }}</div>
                <div class="resume-documents__info-list-subtitle">{{ data.personBodyCharacteristics.clothing_size }}</div>
              </div>
              <div v-if="data.personBodyCharacteristics.waist"
                   class="resume-documents__info-list-item">
                <div class="resume-documents__info-list-title">{{ $tResumePage('Interaction person waist') }}</div>
                <div class="resume-documents__info-list-subtitle">{{ data.personBodyCharacteristics.waist }}</div>
              </div>
              <div v-if="data.personBodyCharacteristics.shoe_size"
                   class="resume-documents__info-list-item">
                <div class="resume-documents__info-list-title">{{ $tResumePage('Interaction person shoe_size') }}</div>
                <div class="resume-documents__info-list-subtitle">{{ data.personBodyCharacteristics.shoe_size }}</div>
              </div>
            </div>
          </div>

          <ResumeInfoSectionInteractionDocuments :documents="data.documents"/>
        </div>
      </div>
    </template>
  </ResumeSection>
</template>

<script>
  import ResumeDocumentsGroup from "@/components/resumeView/ResumeDocumentsGroup"
  import ResumeSection from "@/components/resumeView/ResumeSection"
  import ResumeInfoSectionInteractionDocuments from "@/components/resumeView/ResumeInfoSectionInteractionDocuments"

  export default {
    name: 'ResumeInfoSectionInteraction',
    components: {
      ResumeDocumentsGroup,
      ResumeSection,
      ResumeInfoSectionInteractionDocuments,
    },
    props: ['data', 'isOpenOnMobile', 'isToggleHidden'],
    data() {
      return {}
    },
    computed: {
      dataMain() {
        if(!this.$get(this.data, 'main')) return  null

        const data = this.data.main
        const result = []

        for (const key in data) {
          const value = data[key]

          if(typeof value === 'string') {
            result.push({question: key, answer: value})
          } else if(Array.isArray(value)) {
            value.forEach(item => {
              for (const keyInner in item) {
                const valueInner = item[keyInner]

                result.push({question: keyInner, answer: valueInner})
              }
            })
          } else if (value && (!Array.isArray(value) && !value.length)) {
            result.push({question: key, answer: value})
          }
        }

        return result
      }
    }
  }
</script>

<style lang="less">

</style>
